// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MenuItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/* eslint-disable max-len */

import React, { Component } from 'react';
import classnames from 'classnames';
import { initTooltip, updateTooltip, destroyTooltip } from 'share/utils/Izenda.TooltipUtils';

class MenuItem extends Component {
  componentDidMount() {
    const { item } = this.props;
    if (item.hoverShowTooltip) {
      const tooltipOption = {
        title: item.tooltip,
        trigger: 'hover',
        placement: 'right',
        template:
          '<div class="tooltip tooltip-no-mobile" role="tooltip"><div class="tooltip-arrow info"></div><div class="tooltip-inner info"></div></div>'
      };
      initTooltip(this.linkRef, tooltipOption);
      updateTooltip(this.linkRef, item.tooltip);
    }
  }

  componentWillUnmount() {
    this.props.item.hoverShowTooltip && destroyTooltip(this.linkRef);
  }

  setLinkRef = (com: any): void => {
    this.linkRef = com;
  };

  render() {
    const { item, handleClick, activeKey, enabled } = this.props;
    const collapseIcon = item.items ? <i className="fontello-icon icon-toggle" /> : null;
    const isDisabled = !enabled && item.key !== activeKey;
    const classes = classnames({
      active: item.key === activeKey,
      disabled: isDisabled,
      'enable-hover': item.hoverShowTooltip
    });

    return (
      <a
        onClick={handleClick}
        className={classes}
        data-name={item.key}
        title={item.title}
        ref={this.setLinkRef}
      >
        <i className={item.icon} />
        <span className="izenda-MenuItem-label">
          {item.title}
          {this.props.renderChangedIcon && this.props.renderChangedIcon(item)}
        </span>
        {collapseIcon}
      </a>
    );
  }
}

export default MenuItem;



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.MenuItem.js